// live
export const notes = "https://soap.vetinstant.com/soap_note/";
export const soapNotes = "https://soap.vetinstant.com";
export const baseURL = "https://api.vetinstant.com/api/v2";
export const socketServer = "https://api.vetinstant.com/ws";
export const superTailsUrl =
  "https://supertails-backend.el.r.appspot.com/healthcare/api/v1/vetinstant/webhook";
export const soapNoteLiveTranUrl = "wss://soap.vetinstant.com/ws";

// // dev
// export const notes = "https://soap.vetinstant.com/soap_note";
// export const soapNotes = "https://soap.vetinstant.com";
// export const baseURL = "https://devapi.vetinstant.com/api/v2";
// export const socketServer = "https://devapi.vetinstant.com/ws";
// export const superTailsUrl =
//   "https://st-staging.supertails.com/healthcare/api/v1/vetinstant/webhook";
// export const soapNoteLiveTranUrl = "wss://soap.vetinstant.com/ws";

// export const baseURL = "http://13.233.94.30:1994/api/v2";
// export const socketServer = "http://13.233.94.30.142:1994/ws";

// local
// export const socketServer = 'http://localhost:1994/ws';
// export const notes = 'https://soap.vetinstant.com/soap_note';
// export const baseURL = "http://localhost:1994/api/v2";
